var map = {
	"./delivery-point.json": "fqly",
	"./dots-loading.json": "PJ5X",
	"./loading-point.json": "N9+L",
	"./new.json": "7bW9",
	"./success-animation.json": "vt1w",
	"./trruck-loading.json": "6Btl"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ANHO";